import { useContext, useCallback } from 'react';
import { setRefs } from '../../utils/refHelpers';
import { DropdownStateContext } from '../DropdownStateManager';
import { PopperDropdownContext } from '../PopperDropdownLayout/PopperDropdownContext';
/**
 * Returns the necessary props for a button to interact with our popper/dropdown implementation. Spread these out on your button and you should be good!
 *
 * Required contexts: {@link PopperDropdownContext}, {@link DropdownStateContext}
 */ export function useDropdownToggleProps() {
    const { setToggleRef: setPopperToggleRef  } = useContext(PopperDropdownContext);
    const { setToggleRef: setDropdownToggleRef , isOpen  } = useContext(DropdownStateContext);
    const innerRef = useCallback((node)=>setRefs([
            setPopperToggleRef,
            setDropdownToggleRef
        ], node), [
        setPopperToggleRef,
        setDropdownToggleRef
    ]);
    return {
        innerRef,
        'aria-expanded': isOpen
    };
}
